<template>
  <div class="KaoQing">
    <Header
      title="考勤打卡"
      type="0"
      :route="'/sxKq/index?xnxq=' + this.$route.query.list.xnxq"
    ></Header>
    <NOdata
      v-if="(this.list && this.list.length == 0) || this.list == '[]'"
      title="未查询到考勤打卡"
    ></NOdata>
    <div v-else class="list">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <p>考勤{{ item.pxh }}：（{{ item.kssj }}~{{ item.jssj }}）</p>
        <ul>
          <li v-if="item.kqdd != ''">打卡{{ item.kqdd }}</li>
          <li v-if="item.kqsj != ''">打卡{{ item.kqsj }}</li>
        </ul>
        <span
          @click="daka(item)"
          :class="item.xskqid != '' ? 'update' : ''"
          >{{ item.xskqid != "" ? "更新" : "打卡" }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.$route.query.list = JSON.parse(this.$route.query.list);
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.getsxkqdksj({
        xnxq: this.$route.query.list.xnxq,
        rwfbid: this.$route.query.list.rwfbid
      });
      this.list = res.data;
    },
    daka(item) {
      item.rwfbid = this.$route.query.list.rwfbid;
      let lx = 0;
      if (item.xskqid != "") {
        lx = 1;
      }
      this.$router.push({
        path: "/sxKq/daka",
        query: {
          type: lx,
          list: item,
          params: this.$route.query.list
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.KaoQing .list {
  padding: 0 20px 0 20px;
  .list-item {
    background: #f8f8f8;
    border-radius: 5px;
    margin-bottom: 5%;
    padding: 20px 20px 10px 20px;
    position: relative;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      font-weight: bolder;
      margin-bottom: 10px;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 14px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 5px;
      width: 80%;
    }
    span {
      width: 60px;
      height: 35px;
      background: #7469f8;
      border-radius: 3px;
      position: absolute;
      top: 15px;
      right: 3%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
    }
    .update {
      width: 60px;
      height: 35px;
      background: #ecedfd;
      border-radius: 3px;
      position: absolute;
      top: 25px;
      right: 3%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #7469f8;
      letter-spacing: 0;
      border: 1px dashed gray;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxKq/KaoQing.vue